'use client';

import { useEffect, useRef } from 'react';

import { useBreakpoints } from '@/hooks/use-breakpoints';
import { useElWidth } from '@/hooks/use-el-width';
import { useKeydown } from '@/hooks/use-keydown';
import { useLocalforage } from '@/hooks/use-localforage';

const ACTIVE_KEY = 'is-dev-active';
const IS_DEV_USER_KEY = 'is-dev-user';

export function Dev() {
  const ref = useRef<HTMLDivElement>(null);
  const { active } = useBreakpoints();
  const {
    values: [show],
    setItem,
    store,
  } = useLocalforage<[boolean]>([ACTIVE_KEY]);

  // eslint-disable-next-line no-undef
  const isActive = typeof window !== 'undefined'; // && window.location.host.includes('localhost');
  const width = useElWidth({ isActive, el: ref.current });

  useKeydown(
    {
      isActive,
      callback: (e) => {
        const event = e as KeyboardEvent;
        
        if (event.ctrlKey && (event.key === '?' || event.key === '/')) {
          setItem(ACTIVE_KEY, !show);
          setItem(IS_DEV_USER_KEY, true);
        }
      },
    },
    [show]
  );

  useEffect(() => {
    typeof show === 'boolean' && window.document.body.setAttribute('data-dev', show.toString());
  }, [show]);

  useEffect(() => {
    if (store) {
      const params = new URLSearchParams(window.location.search);

      if (params.has('dev')) {
        store.setItem(IS_DEV_USER_KEY, true);
      } else if (params.has('prod')) {
        store.setItem(IS_DEV_USER_KEY, false);
      }
    }
  }, [store]);

  return show ? (
    <div className='fixed bottom-0 left-0 right-0 z-50 p-4 bg-gray-200 bg-opacity-75 flex justify-center gap-6' ref={ref}>
      <span className='text-sm'>{active}</span>
      <span className='text-sm'>{width}px</span>
    </div>
  ) : null;
}

export function useIsDevUser() {
  const {
    values: [isDevUser],
  } = useLocalforage<[boolean]>([IS_DEV_USER_KEY]);

  return isDevUser;
}
